module.exports = __webpack_public_path__ + "static/media/Read.247e4dea.svg";